import { render, staticRenderFns } from "./RejectReasonWizard.vue?vue&type=template&id=ebd6198e&scoped=true"
import script from "./RejectReasonWizard.vue?vue&type=script&lang=js"
export * from "./RejectReasonWizard.vue?vue&type=script&lang=js"
import style0 from "./RejectReasonWizard.vue?vue&type=style&index=0&id=ebd6198e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd6198e",
  null
  
)

export default component.exports